export default __webpack_public_path__ + "static/media/personaldiarytop1.de6b9f76.png";